import { Button, Typography } from "@mui/material";
import { ReactNode } from "react";

import AppDialog from "components/common/AppDialog";

interface DeleteJobConfirmDialogProps {
  open: boolean;
  title: string;
  message: ReactNode;
  onCancel: () => void;
  onConfirm: () => void;
  confirmDisabled?: boolean;
  busy?: boolean;
}

/**
 * Shared confirmation for every job-delete action in Bots Management. A job's
 * own S3 data - its log archives and its per-job matches files - always goes
 * with it: a job row without its logs is a job nobody can read. The folder is
 * shared with other jobs of the same document type, so the roster, the legacy
 * shared matches file, screenshots and the downloaded documents stay.
 */
export default function DeleteJobConfirmDialog({
  open,
  title,
  message,
  onCancel,
  onConfirm,
  confirmDisabled = false,
  busy = false,
}: DeleteJobConfirmDialogProps) {
  return (
    <AppDialog
      open={open}
      onClose={() => !busy && onCancel()}
      title={title}
      actions={
        <>
          <Button onClick={onCancel} disabled={busy}>
            Cancel
          </Button>
          <Button
            color="error"
            variant="contained"
            disabled={confirmDisabled || busy}
            onClick={onConfirm}
          >
            Delete
          </Button>
        </>
      }
    >
      <Typography variant="body2">{message}</Typography>
      <Typography variant="body2" color="text.secondary" sx={{ mt: 1 }}>
        The S3 data of the deleted job(s) goes too: the log archives of their tasks and their own
        matches files. The logs are the only record of which employees were processed, so a new job
        over the same folder starts from scratch. The roster, the shared matches file and the
        documents themselves stay.
      </Typography>
    </AppDialog>
  );
}
